module.exports = __webpack_public_path__ + "img/d2935_1295_310_area_a2_cmyk_eci.6618d4fc.jpg";